module.exports = __webpack_public_path__ + "static/media/Icon-Rates.acbdf8e2.svg";